import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CaptureRequestsList from './components/CaptureRequestsList'

const CaptureRequests = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Capture Requests Management</h3>
          <h3 className="page-subhead subhead">View capture requests made by users so far!</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <CaptureRequestsList />
        </Col>
      </Row>
    </Container>
  );
};

export default CaptureRequests;